<app-breadcrumb [productName]="product?.name" class="breadcrumb"></app-breadcrumb>



<div class="product-container">
  <mat-tab-group [selectedIndex]="selectedTabIndex">
    <mat-tab label="Product Info">
      <div *ngIf="product; else loadingProduct">
        <div class="section">
          <h2>{{ product.name }}</h2>
          <p><strong>Description:</strong> {{ product.description }}</p>
          <p><strong>Price:</strong> ${{ product.price }}</p>
          <p><strong>On Sale:</strong> {{ product.is_on_sale ? 'Yes' : 'No' }}</p>
          <ng-container *ngIf="product.is_on_sale">
            <p><strong>Sale Price:</strong> ${{ product.sale_price }}</p>
          </ng-container>
          <p><strong>Status:</strong> {{ product.status || 'Published' }}</p>
          <p><strong>Groups:</strong> {{ getGroupNames(product.groups) }}</p>
          <p><strong>Categories:</strong> {{ getCategoryNames(product.categories) }}</p>
        </div>
        <hr />
      </div>
      <ng-template #loadingProduct>
        <p>Loading product details...</p>
      </ng-template>
    </mat-tab>

    <mat-tab label="Variants">
      <br />
      <mat-form-field appearance="outline">
        <mat-label>Channel</mat-label>
        <mat-select [(value)]="selectedChannel">
          <mat-option *ngFor="let ch of channels" [value]="ch.channel_code">
            {{ ch.display_name }}
          </mat-option>                  
        </mat-select>
      </mat-form-field>
    
      <div style="margin: 1rem 0;">
        <button mat-raised-button class="create-variant-btn" (click)="createVariant()">
          <mat-icon>add</mat-icon> Create Variant
        </button>
      </div>
    
      <div *ngIf="variants.length > 0; else noVariants" class="section">
        <table class="variant-table">
          <thead>
            <tr>
              <th>Variant Key</th>
              <th *ngFor="let key of getAllAttributeKeys()">Attribute: {{ key }}</th>
              <th>Price</th>
              <th>Price ({{selectedChannel}})</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let variant of variants" (click)="goToVariantDetail(variant)">
              <td>{{ variant.variant_key }}</td>
              <td *ngFor="let key of getAllAttributeKeys()">
                {{ variant.attributes[key] || '—' }}
              </td>
              <td>${{ variant.price }}</td>
              
              <td>
                <ng-container *ngIf="getChannelPricing(variant, selectedChannel) as priceInfo">
                  <span [matTooltip]="getTooltipForChannel(priceInfo, variant)">
                    <strong *ngIf="priceInfo.is_on_sale && priceInfo.sale_price != null" class="sale-price">
                      ${{ priceInfo.sale_price }} <span class="sale-label">(Sale)</span>
                    </strong>
                    <strong *ngIf="!priceInfo.is_on_sale">
                      ${{ priceInfo.price }}
                    </strong>
                  </span>
                </ng-container>
                <ng-container *ngIf="!hasChannelPricing(variant, selectedChannel)">
                  —<br />
                  <span class="base-price">Base: ${{ variant.price }}</span>
                </ng-container>
              </td>
              <td>
                <div class="action-buttons">
                  <button (click)="goToVariantDetail(variant)">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-icon-button (click)="deleteVariant(variant, $event)" matTooltip="Delete">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    
      <ng-template #noVariants>
        <p>No variants found.</p>
      </ng-template>
    </mat-tab>
    
  </mat-tab-group>
</div>
